// extracted by mini-css-extract-plugin
module.exports = {"large":"ListComponentFrame_large__wQbo4"};